<script setup lang="ts">
import { cva } from 'class-variance-authority'

interface Props {
    count: number
    size?: 'sm' | 'md'
    hide?: boolean
}

withDefaults(defineProps<Props>(), {
    size: 'md',
    hide: true
})

const badgeClasses = cva(
    [
        'inline-flex',
        'min-w-fit',
        'items-center',
        'justify-center',
        'rounded-md',
        'bg-gray-200',
        'font-semibold',
        'text-gray-600',
        'transition-opacity'
    ],
    {
        variants: {
            size: {
                sm: ['size-5', 'text-xs'],
                md: ['size-6', 'text-xs']
            },
            hide: {
                true: ['opacity-0', 'group-hover:opacity-100'],
                false: ['opacity-100']
            }
        }
    }
)
</script>

<template>
    <span :class="badgeClasses({ size, hide })">
        {{ count }}
    </span>
</template>
